import $ from 'jquery';
import { handleAiEdit } from './index';

export default function initAiEditListeners() {
  // Remove existing listener to prevent duplicates
  $('body').off('click', '[data-ai-edit]');

  // Attach namespaced event listener
  $('body').on('click', '[data-ai-edit]', function (e) {
    e.preventDefault();
    const prompt = $(this).data('ai-edit');
    handleAiEdit(prompt);
  });
}
